import type { ReactNode } from 'react';

export const symbol_rowing: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m713-21-82-82q-5-5-7-10t-2-11v-50L301-495q-6 2-12.5 3t-11.5 1v-53q49-2 111-29t93-61l58-63q12-13 27.5-21t32.5-8q32 0 55 23t23 55v248q0 30-13.5 61T630-297L516-411v-174q-30 26-67 46t-70 32l288 288h50q6 0 11 2t10 7l82 82q9 9 9 21t-9 21l-65 65q-9 9-21 9t-21-9ZM350-288 227-166q-9 9-22 9t-22-9q-9-9-9.5-22.5T183-211l183-182 105 105H350Zm202.5-507.5Q531-817 531-847t21.5-51.5Q574-920 604-920t51.5 21.5Q677-877 677-847t-21.5 51.5Q634-774 604-774t-51.5-21.5ZM258.5-499q-7.5-8-7.5-19t7.5-18.5Q266-544 277-544t19 7.5q8 7.5 8 18.5t-8 19q-8 8-19 8t-18.5-8Z"
		/>
	</svg>
);
